/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import type { TranslatorProps } from 'react-i18next';

import Tooltip from '@material-ui/core/Tooltip';

import styles from './FormSection.module.scss';

type TypeProps = {|
  form: Object,
  children: Array<*>,
  section: string,
|} & TranslatorProps;

@observer
export default class FormSection extends React.Component<*> {
  render(): React.Element<*> {
    const { form, children, section, fluid }: TypeProps = this.props;

    const label = form && section ? form.$(`${section}`).label : '';

    const sectionClassName = fluid
      ? styles['form-section-content-fluid']
      : styles['form-section-content'];

    const labelHTML =
      label.indexOf(' ') === -1 ? (
        <Tooltip title={label}>
          <h2 className={styles['ellipsis-text']}>{label}</h2>
        </Tooltip>
      ) : (
        <h2>{label}</h2>
      );

    return (
      <div className={styles['form-section']}>
        <div className={styles['form-section-heading']}>{labelHTML}</div>
        <div className={sectionClassName}>{children}</div>
      </div>
    );
  }
}
